<template>
  <dialogModule
    top="3"
    width="80%"
    :title="$t('changePrice.title')"
    v-if="changPriceVisible"
    :closeOnPressEscape="false"
    :dialogVisible="changPriceVisible"
    @close="close">
    <span slot="close" class="el-icon-close close-icon" @click="close"></span>
    <section slot="content" class="content-dialog">
      <div class="section-form">
        <div class="card-title row align-center">
          <i></i>
          <span>{{$t('changePrice.applicationInfo')}}</span>
        </div>
        <div class="row align-center">
          <div class="form-item">
            <div>{{$t('changePrice.submitter')}}</div>
            <el-select class="value" size="small" v-model="form.userId" :placeholder="$t('changePrice.selectPrompt')">
              <el-option v-for="item in userList" :key="item.id" :label="item.realName" :value="item.id"> </el-option>
            </el-select>
          </div>
          <div class="form-item">
            <div>{{$t('changePrice.submitTime')}}</div>
            <el-date-picker
              disabled
              class="value"
              size="small"
              v-model="form.date"
              type="datetime"
              :placeholder="$t('changePrice.selectDateTime')">
            </el-date-picker>
          </div>
          <div class="form-item">
            <div>{{$t('changePrice.shopName')}}</div>
            <el-input disabled class="value" size="small" v-model="form.deptName"></el-input>
          </div>
          <div class="form-item">
            <div>{{$t('changePrice.originalPrice')}}</div>
            <el-input disabled class="value" size="small" v-model="form.oldMoneyAll"></el-input>
          </div>
          <div class="form-item">
            <div>{{$t('changePrice.newPrice')}}</div>
            <el-input disabled class="value" size="small" v-model="form.newMoneyAll"></el-input>
          </div>
          <div class="form-item">
            <div>{{$t('changePrice.changeAmount')}}</div>
            <el-input disabled class="value" size="small" v-model="form.changePrice"></el-input>
          </div>
        </div>
        <div class="form-item">
          <div>{{$t('changePrice.remark')}}</div>
          <el-input
            class="text-area"
            type="textarea"
            rows="3"
            :placeholder="$t('changePrice.inputPrompt')"
            v-model="form.description"></el-input>
        </div>
      </div>
      <div class="section-goods">
        <div class="card-title row align-center">
          <i></i>
          <span>{{$t('changePrice.priceChangedGoods')}}</span>
        </div>
        <div class="goods-table">
          <grid-manager :option="gridOption"></grid-manager>
        </div>
      </div>
      <div class="section-flows">
        <FlowSteps :flowTypeId="hrFlowTypeId"></FlowSteps>
      </div>
      <div class="row space-center align-center action-btn">
        <el-button class="btn" @click="close" :disabled="loading">{{$t('changePrice.cancel')}}</el-button>
        <el-button
          v-if="!approveFail"
          class="btn"
          type="primary"
          :disabled="loading"
          :loading="loading"
          @click="sureSubmit"
          >{{$t('changePrice.confirm')}}</el-button
        >
        <el-button v-else class="btn" type="primary" :disabled="loading" :loading="loading" @click="approveAgain"
          >{{$t('changePrice.confirm')}}</el-button
        >
      </div>
    </section>
  </dialogModule>
</template>
<script>
import moment from 'moment'
import FlowSteps from '@/components/FlowSteps.vue'
import dialogModule from '@/components/dialogModule.vue'
import { posSubmitPosAlterPrice, queryShoppGuide, returnSalesSubmit } from '@/libs/http/modules/posOrder'
export default {
  name: 'returnChangePrice',
  props: {
    approveList: {
      type: Array,
      default: () => []
    },
    approveInfo: {
      type: Object,
      default: () => {}
    },
    tableData: {
      type: Array,
      default: () => []
    },
    reduceResult: {
      type: Object,
      default: () => {}
    },
    hrFlowTypeId: {
      type: String,
      default: () => ''
    },
    snNo: {
      type: String,
      default: () => ''
    },
    ticketInfoList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    FlowSteps,
    dialogModule
  },
  data() {
    return {
      changPriceVisible: true,
      form: {
        userId: '',
        date: moment().format('yyyy-MM-DD HH:mm'),
        deptName: this.$cache.local.get('deptName'),
        description: '',
        oldMoneyAll: '',
        newMoneyAll: '',
        changePrice: ''
      },
      back: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/return.png") : require("@/assets/images/vnReturn.png"),
      gridOption: {
        gridManagerName: 'return-goods-change',
        firstLoading: true,
        height: 'auto',
        isCombSorting: true,
        supportAutoOrder: false,
        supportCheckbox: false,
        supportMenu: false,
        supportConfig: true,
        disableAutoLoading: true,
        disableBorder: false,
        disableLine: true,
        columnData: [
          {
            key: 'operationType',
            text: this.$t('gridManage.columnType'),
            align: 'center',
            width: '80px',
            template: () => {
              return `
								<div>
								    <img style="width:40px;height:40px;" :src="back" />
								</div>
						    `
            }
          },
          {
            key: 'goodsInfo',
            text: this.$t('gridManage.columnGoodsInfo'),
            align: 'center',
            width: '360px',
            template: () => {
              return `
								<div class="row" style="text-align:left;">
									<div style="width:102px;height:92px;margin-right:10px;position: relative;overflow: hidden;flex-shrink: 0;">
										<el-image v-if="row.imageList && row.imageList.length" style="width:102px;height:92px;border-radius:4px;" :preview-src-list="row.imageList" :src="row.imageList[0]"></el-image>
                    <div v-else class="row align-center space-center" style="background: #eee;width:102px;height:92px;border-radius:4px;color: #999;white-space: pre-wrap;text-align: center;">{{$t('gridManage.noGoodsImage')}}</div>
                  </div>
                  <div class="column space-between" style="height:90px;">
										<div style="font-size:18px;color:#333;">{{row.goodsName}}</div>
										<div style="font-size:14px;color:#999;">{{$t('gridManage.goodsNo')}}：{{row.goodsNo}}</div>
										<div style="font-size:14px;color:#999;">{{$t('gridManage.goodsBarCode')}}：{{row.barCode}}</div>
                  </div>
								</div>
							`
            }
          },
          {
            key: 'attr',
            text: this.$t('gridManage.columnAttr'),
            align: 'center',
            width: '140px',
            template: () => {
              return `
								<div v-if="row.attr" class="row space-center align-center text-center" style="border:1px solid #DEEEF9;background:#fff;line-height:34px;border-radius:2px;">
									<p v-for="(item, index) in row.attr.slice(0, 2)" :key="item.code">{{item.value}}
									  	<span v-if="index == 0" style="margin:0 3px;">,</span>
									</p>
							  	</div>
                    		`
            }
          },
          {
            key: 'tagPrice',
            text: this.$t('gridManage.tagPrice'),
            align: 'center',
            template: () => {
              return `
								<div style="font-size: 18px;">{{row.tagPrice}}đ</div>
							`
            }
          },
          {
            key: 'defaultDiscount',
            text: this.$t('gridManage.discount'),
            align: 'center',
            template: () => {
              return `
								<div style="font-size: 18px;">{{(row.realPrice / row.tagPrice * 10).toFixed(1)}}%</div>
							`
            }
          },
          {
            key: 'retreatNumber',
            text: this.$t('gridManage.number'),
            align: 'center',
            template: () => {
              return `
								<div style="font-size: 18px;">{{row.retreatNumber}}</div>
							`
            }
          },
          {
            key: 'realPrice',
            text: this.$t('gridManage.originalSellingPrice'),
            align: 'center',
            template: () => {
              return `
								<div style="font-size: 18px;color:rgb(255,158,0);">{{row.realPrice}}đ</div>
							`
            }
          },
          {
            key: 'originPrice',
            text: this.$t('gridManage.agoRealPrice'),
            align: 'center',
            template: () => {
              return `
								<div style="font-size: 18px;color:rgb(255,158,0);">{{row.originPrice}}đ</div>
							`
            }
          },
          {
            key: 'retreatPrice',
            text: this.$t('gridManage.realPrice'),
            align: 'center',
            template: () => {
              return `
								<div style="color:#F8475F;font-size: 18px;">{{row.retreatPrice}}đ</div>
						    `
            }
          },
          {
            key: 'totalPrice',
            text: this.$t('gridManage.beforeTotalPrice'),
            align: 'center',
            template: () => {
              return `
								<div style="font-size: 18px;color:rgb(255,158,0);">{{row.totalPrice}}đ</div>
						    `
            }
          },
          {
            key: 'totalRetreatPrice',
            text: this.$t('gridManage.afterTotalPrice'),
            align: 'center',
            template: () => {
              return `
								<div style="color:#F8475F;font-size: 18px;">{{row.totalRetreatPrice}}đ</div>
						    `
            }
          }
        ],
        ajaxData: this.showGoodsTable
      },
      goodsList: [],
      userList: [],
      changeValue: 0,
      loading: false,
      ordingId: '',
      approveFail: false
    }
  },
  created() {
    this.goodsList = this.approveList
    this.form.oldMoneyAll = this.approveList.reduce((c, R) => c + Number(R.totalPrice || 0), 0)
    this.form.newMoneyAll = this.approveList.reduce((c, R) => c + Number(R.totalRetreatPrice || 0), 0)
    this.changeValue = (this.form.newMoneyAll - this.form.oldMoneyAll).toFixed(2)
    this.form.changePrice = this.changeValue > 0 ? this.$t('changePrice.addPrice', {money: Math.abs(this.changeValue)}) : this.$t('changePrice.miniPrice', {money: Math.abs(this.changeValue)})
    this.queryGuide()
  },
  methods: {
    close() {
      if (this.loading) {
        return this.$message({ type: 'error', message: this.$t('changePrice.operationInProgress'), duration: 2000, showClose: true })
      }
      this.changPriceVisible = false
      this.$emit('close')
    },
    showGoodsTable() {
      return new Promise((resolve, reject) => {
        const tableData = {
          data: this.goodsList
        }
        resolve(tableData)
      })
    },
    queryGuide() {
      queryShoppGuide({
        page: '1',
        pageSize: '50'
      })
        .then(res => {
          this.userList = res.items || []
          if (this.approveInfo.userName) {
            this.userList.forEach(item => {
              if (item.realName === this.approveInfo.userName) {
                this.form.userId = item.id
              }
            })
          }
        })
        .catch(() => {})
    },
    sureSubmit() {
      if (!this.form.userId) {
        return this.$message({ type: 'error', message: this.$t('changePrice.selectSubmitter'), duration: 2000, showClose: true })
      }
      if (this.$cache.local.get('saleQuality') === 'ZY' && !this.form.description) {
        return this.$message({ type: 'error', message: this.$t('changePrice.fillApprovalRemark'), duration: 2000, showClose: true })
      }
      this.approveFail = false
      this.loading = true
      let reqData = {
        hasAlterPriceInfo: 'Y',
        goodInfos: this.tableData,
        reduceResult: this.reduceResult,
        remark: this.approveInfo.remark,
        orderId: this.approveInfo.orderId,
        orderTypeId: this.approveInfo.orderTypeId
      }
      const cashierItem = JSON.parse(this.$cache.local.get('cashierDeskItem'))
      if (cashierItem) {
        reqData['terminalId'] = cashierItem.id
      }
      if(this.ticketInfoList.length){
        reqData['couponRetreatInfos'] = this.ticketInfoList
      }
      returnSalesSubmit(reqData)
        .then(res => {
          this.ordingId = res.id
          this.submitApprove()
        })
        .catch(error => {
          this.loading = false
          this.$message({ showClose: true, message: error, type: 'error', duration: 2000 })
        })
    },
    submitApprove() {
      let list = this.goodsList.map(item => {
        return {
          sku: item.sku,
          number: item.number,
          beforePrice: item.originPrice,
          afterPrice: item.retreatPrice,
          oldPrice: item.realPrice
        }
      })
      posSubmitPosAlterPrice({
        alterType: '1',
        goodsInfos: list,
        invoicesId: this.ordingId,
        submitUser: this.form.userId,
        hrFlowTypeId: this.hrFlowTypeId,
        description: this.form.description,
        oldInnerSn: this.snNo
      })
        .then(data => {
          this.loading = false
          this.changPriceVisible = false
          this.$emit('sure')
          this.$message({ type: 'success', message: this.$t('changePrice.submitSuccess'), duration: 2000, showClose: true })
        })
        .catch(err => {
          this.loading = false
          this.approveFail = true
          this.$message({ type: 'error', message: err, duration: 2000, showClose: true })
        })
    },
    approveAgain() {
      this.loading = true
      this.submitApprove()
    }
  }
}
</script>
<style lang="scss" scoped>
.close-icon {
  color: #999;
  padding: 10px;
  margin-right: -10px;
  cursor: pointer;
}
.content-dialog {
  height: 84vh;
  overflow: auto;
}
.card-title {
  i {
    width: 4px;
    height: 16px;
    background: #0b83f3;
    border-radius: 2px;
    margin-right: 6px;
  }
  span {
    font-size: 16px;
  }
}
.section-form {
  margin: 15px 20px;
  > div {
    margin-bottom: 20px;
  }
  .form-item {
    margin-right: 20px;
    div {
      margin: 5px 0;
    }
    .value {
      width: 220px;
    }
    .text-area {
      width: 100%;
    }
  }
}
.section-goods {
  border-top: 1px solid #eee;
  padding: 15px 20px;
  .goods-table {
    margin-top: 15px;
  }
}
.section-flows {
  border-top: 1px solid #eee;
  padding: 10px;
}
.action-btn {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  .btn {
    width: 130px;
  }
}
</style>
